// import Calendar from "@/utils/calendar";

export const taglist = [
  { value: 1, label: "转正品" },
  { value: 2, label: "退货" },
  { value: 3, label: "新采购单入库" },
  { value: 10, label: "转废弃区" },
  { value: 11, label: "转用户库存" },
];
const warehouselist = ['待处理','已处理']
const servicelist =['未处理','已处理','处理中']

export const columns = [
  {
    title: "#",
    dataIndex: "id",
    key: "id",
    width: 50,
    fixed:'left',
    customRender: (text, record, index) => {
      return index + 1;
    },
  },
  {
    title: "物流单号",
    dataIndex: "expressNo",
    key: "expressNo",
  },
  {
    title: "位置",
    dataIndex: "gridCode",
    key: "gridCode",
  },
  {
    title: "处理结果",
    dataIndex: "tag",
    key: "tag",
    // scopedSlots: {
    //   customRender: "tag",
    // },
    customRender: (text,record) => {
      return text?taglist.filter(v => v.value === text)?.[0].label:'-'
    },
  },
  {
    title: "处理内容",
    dataIndex: "tagName",
    key: "tagName",
    customRender: (text,record) => {
      if(record.tag == 2){
        return `${record.refundAddress} ${record.refundPhone} ${record.refundContact}`
      }
      if(record.tag == 3){
        return `关联新采购单号 ${record.purchaseNew}`
      }
      return text ?? '-'
    },
  },
  {
    title: "采购备注",
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "异常图片",
    dataIndex: "imgs",
    key: "imgs",
    width: 100,
    scopedSlots: {
      customRender: "errorImg",
    },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    key: "createTime",
  },
  {
    title: "创建人",
    dataIndex: "createrName",
    key: "createrName",
    customRender: (text,record) => {
        return text||'-'
    },
  },
  {
    title: "处理时间",
    dataIndex: "purchaseProcessTime",
    key: "purchaseProcessTime",
  },
  {
    title: "处理人",
    dataIndex: "purchaseOperatorName",
    key: "purchaseOperatorName",
    customRender: (text,record) => {
        return text||'-'
    },
  },
  {
    title: "操作",
    dataIndex: "idAction",
    key: "idAction",
    width:170,
    fixed: "right",
    scopedSlots: {
      customRender: "action",
    },
  },
];

export const dataSource = [
  {
    warehouse: "1",
    regionName: "1",
    regionContact: "1",
    contactPhone: "1",
    address: "1",
    total: "1",
    result: "1",
    num: "1",
    type: "1"
  },
];

export const logColumns = [
  {
    title: "场景",
    dataIndex: "operateNodeName",
    key: "operateNodeName",
  },
  {
    title: "内容",
    dataIndex: "context",
    key: "context",
  },
  {
    title: "操作人",
    dataIndex: "creatorName",
    key: "creatorName",
  },
  {
    title: "操作时间",
    dataIndex: "createTime",
    key: "createTime",
  },
]
